import * as S from "./styles"
import PoweredByQITech from "../../components/PoweredByQITech"
import { styled } from '../../modules';
import { useThemeContext } from "../../contexts/ThemeContext";
import QISignTheme from "../../interfaces/Theme";

export const LoadingPage = ({ clientThemeSettings: clientThemeSettingsProp }: { clientThemeSettings?: QISignTheme } = {}) => {

    const { clientThemeSettings: clientThemeSettingsCtx } = useThemeContext();
    const clientThemeSettings = clientThemeSettingsProp ?? clientThemeSettingsCtx;
    

    const SpinnerWrapper = styled.div`
        position: relative;
        width: 120px;
        height: 120px;
        margin-bottom: 16px;
    `;

    const Logo = styled.img`
        width: 60px;
        height: 60px;
        position: absolute;
        object-fit: contain;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
    `;

    const LoadingSpinner = styled.div`
        width: 120px;
        height: 120px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;

        svg {
            width: 100%;
            height: 100%;
            display: block;
            animation: spin 1.2s linear infinite;
            transform-origin: center;
            color: ${({ color }) => color || '#333'};
        }

        @keyframes spin {
            from {
            transform: rotate(0deg);
            }
            to {
            transform: rotate(360deg);
            }
        }
    `;

    return (
        <S.Container>
            <S.Placeholder />
            <S.Center>
                <SpinnerWrapper>
                    {
                        clientThemeSettings?.loading_logo_url && <Logo src={clientThemeSettings?.loading_logo_url} alt="Logo" />
                    }
                    {
                        clientThemeSettings?.button_color ?
                        <LoadingSpinner color={clientThemeSettings?.button_color}>
                            <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                <circle
                                    cx="25"
                                    cy="25"
                                    r="20"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeDasharray="100"
                                    strokeDashoffset="25"
                                />
                            </svg>
                        </LoadingSpinner>
                        :
                        <LoadingSpinner>
                            <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                <circle
                                    cx="25"
                                    cy="25"
                                    r="20"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeDasharray="100"
                                    strokeDashoffset="25"
                                />
                            </svg>
                        </LoadingSpinner>
                    }
                    
                </SpinnerWrapper>
                <S.Title>Carregando...</S.Title>
            </S.Center>
            <S.Base>
                <PoweredByQITech />
            </S.Base>
        </S.Container>
    )
}